<template>
    <div class="configOwnerOptionVue">
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <div class="col-md-6 col-md-offset-3 o-config-side-padd c-common-box-shadow u-bg-color-fff">
                <div class="owner-option">

                    <div class="col-md-12 o-no-padding">
                        <div class="col-md-6">
                            <h3>Admin Configuration<span class="c-common-btn--inverse-icon-orange"><!--<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> --></span></h3>
                        </div>
                        <div class="col-md-6 text-right">
                             <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="back()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="saveToken()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <!-- <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Internet Confirm:</label>
                                            </div>
                                            <div class="radio o-custom-radio">
                                                <label>
                                                    Yes
                                                    <input type="radio" name="o5" value="1">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                </label>
                                            </div>
                                            <div class="radio o-custom-radio">
                                                <label>
                                                    No
                                                    <input type="radio" name="o5" value="0">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <p class="ps2 o-margin-top5">If enabled, users may confirm and deny their own calls via the web application schedule page.</p></div>
                            </div>
                        </div> -->
                        <!-- <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Disable Pass Option:</label>
                                            </div>
                                            <div class="radio o-custom-radio">
                                                <label>
                                                    Yes
                                                    <input type="radio" name="pass5" value="1">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                </label>
                                            </div>
                                            <div class="radio o-custom-radio">
                                                <label>
                                                    No
                                                    <input type="radio" name="pass5" value="0">
                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <p class="ps2 o-margin-top5">If enabled,the Pass option will be removed from the web application schedule and phone pages.</p></div>
                            </div>
                        </div> -->
                        <!-- <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Default Sort:</label>
                                            </div>
                                            <div class="clearfix"></div>
                                            <div class="o-cutsomSelect">
                                                <select >
                                                    <option value="">SELECT</option>
                                                    <option value="fname_asc">FirstLast (Employee name)</option>
                                                    <option value="fname_desc">LastFirst (Employee name)</option>

                                                    <option value="wishlist_asc">Wishlist Timestamp(Ascending)</option>
                                                    <option value="wishlist_desc">Wishlist Timestamp (Decending)</option>

                                                    <option value="participation_asc">Participation(Ascending)</option>
                                                    <option value="participation_desc">Participation(Decending)</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <p class="ps2">An employee with less than this amount of time between shifts will be flagged in yellow on the assignment page.</p></div>
                            </div>
                        </div> -->
                        <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Bandwidth Token:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <input type="text" v-model="tokenConfig.bandwidth_token" name="" class="form-control" rows="4" placeholder="Enter your token">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Bandwidth Secret Key:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <input type="text" v-model="tokenConfig.bandwidth_secret" name="" class="form-control" rows="4" placeholder="Enter your token">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Bandwidth Application Id:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <input type="text" v-model="tokenConfig.bandwidth_application_id" name="" class="form-control" rows="4" placeholder="Enter your token">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="u-padding-15">
                            <!-- <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Bandwidth Application Id:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <input type="text" v-model="tokenConfig.bandwidth_application_id" name="" class="form-control" rows="4" placeholder="Enter your token">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <h3 class="o-super-title">Employee Report Template File(.rdlx-json):</h3>
                                        <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                            <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{new_files[0].selected?'Change Files':'Add New Files'}}</button>
                                            <input type="file" @change="addFileForAddNewJob($event,0)" />
                                            <button @click="uploadService()" v-if="new_files[0].selected" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i>Upload</button>
                                            <a :href="tokenConfig.gcs_employee_template" v-if="tokenConfig.gcs_employee_template&&tokenConfig.gcs_employee_template!=''" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-download" aria-hidden="true"></i>Download</a>
                                            <span class="addJobTypeArea">
                                                <span class="addJob-title">{{snippet(new_files[0].name)}}</span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Employee Report Data Source link:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <input type="text" v-model="tokenConfig.employee_json_payload_url" name="" class="form-control" rows="4" placeholder="Enter your token">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <h3 class="o-super-title">Wishlist Summary Report Template File(.rdlx-json):</h3>
                                        <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                            <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{wishlist_files[0].selected?'Change Files':'Add New Files'}}</button>
                                            <input type="file" @change="addFileForWishlistSummery($event,0)" />
                                            <button @click="uploadWishlistSummaryTemplate()" v-if="wishlist_files[0].selected" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i>Upload</button>
                                            <a :href="tokenConfig.gcs_wishlist_summary_template" v-if="tokenConfig.gcs_wishlist_summary_template&&tokenConfig.gcs_wishlist_summary_template!=''" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-download" aria-hidden="true"></i>Download</a>
                                            <span class="addJobTypeArea">
                                                <span class="addJob-title">{{snippet(wishlist_files[0].name)}}</span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Wishlist Summary Report Data Source link:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <input type="text" v-model="tokenConfig.employee_wishlist_summary_json_payload_url" name="" class="form-control" rows="4" placeholder="Enter Wishlist Summary Json">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <h3 class="o-super-title">Archive Report Template File(.rdlx-json):</h3>
                                        <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                            <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{new_files[0].selected?'Change Files':'Add New Files'}}</button>
                                            <input type="file" @change="addFileForAddNewJob($event,0)" />
                                            <button @click="uploadService()" v-if="new_files[0].selected" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i>Upload</button>
                                            <a :href="tokenConfig.gcs_archive_template" v-if="tokenConfig.gcs_archive_template" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-download" aria-hidden="true"></i>Download</a>
                                            <span class="addJobTypeArea">
                                                <span class="addJob-title">{{snippet(new_files[0].name)}}</span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Archive Report Data Source link:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <input type="text" v-model="tokenConfig.archive_json_payload_url" name="" class="form-control" rows="4" placeholder="Enter your token">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom-only u-padding-15">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Sync Freshchat Channels:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <!-- <input type="text" v-model="bandwidthToken" name="" class="form-control" rows="4" placeholder="Enter your token"> -->
                                                <a href="javascript: void(0)" @click="syncChannels()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Click to Sync Channels</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="form-group o-no-margin-bottom">
                                        <div class="clearfix">
                                            <div class="form-group-left">
                                                <label>Re-Authorize:</label>
                                            </div>
                                            <div class="form-group-right">
                                                <!-- <input type="text" v-model="bandwidthToken" name="" class="form-control" rows="4" placeholder="Enter your token"> -->
                                                <a href="https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?response_type=code&client_id=508718336686-orrglbu6m6of0733u8rq43ak5nndc5ob.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive.file%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive&redirect_uri=https%3A%2F%2Fadmin.callsteward.ca%2Fapi%2Fv2%2FtestingGdriveAuth&access_type=offline&prompt=consent&service=lso&o2v=2&flowName=GeneralOAuthFlow" target="_blank" class="c-common-btn c-common-btn--small gsheet">
                                                    <!-- <i class="fa fa-download" aria-hidden="true"></i> Click to Sync Channels -->
                                                    <span><img class="gsheet-logo" src="static/assets/images/Document-icon.png" /></span>
                                                    <span class="gsheet-text">G-Sheet</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    export default {
        data() {
            return {
                tokenConfig:{
                    id:'',
                    bandwidth_token:'',
                    bandwidth_secret:'',
                    bandwidth_application_id:'',
                    employee_json_payload_url:'',
                    archive_json_payload_url: '',
                    gcs_employee_template:'',
                    gcs_archive_template: '',
                    gcs_wishlist_summary_template: ''
                },
                new_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
                wishlist_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
                gsheet_re_auth_link: "https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?response_type=code&client_id=508718336686-orrglbu6m6of0733u8rq43ak5nndc5ob.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive.file%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive&redirect_uri=https%3A%2F%2Fstage-callsteward.com%2Fapi%2Fv2%2FtestingGdriveAuth&access_type=offline&prompt=consent&service=lso&o2v=2&flowName=GeneralOAuthFlow"
            };
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID"
            })
        },
        methods: {
            addFileForAddNewJob(e, index) {
                var input = e.target;
                //console.log(input.files);
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true; 
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                        
                        //console.log( this.new_files, index);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }
                }
            },

            addFileForWishlistSummery(e, index) {
                var input = e.target;
                //console.log(input.files);
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.wishlist_files[index].img = img
                            this.wishlist_files[index].name = input.files[0].name,
                            this.wishlist_files[index].status = true; 
                            this.wishlist_files[index].uploading = false;
                            this.wishlist_files[index].uploaded = false;
                            this.wishlist_files[index].path = '';
                            this.wishlist_files[index].label = 'Report';
                            this.wishlist_files[index].type = type[0];
                            this.wishlist_files[index].fileExtension = this.setPicture(type[0]);
                            this.wishlist_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);     
                        //console.log( this.wishlist_files, index);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }
                }
            },
            
            snippet(value) {
                if (value.length > 25)
                    return value.slice(0, 25) + '  ...';
                else
                    return value;
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            uploadService() {
                this.loading = true;
                service.post('client/uploadEmployeeTemplate', {
                    'image_file': this.new_files[0].img,
                    'file_name': this.new_files[0].name,
                    // 'client_id': this.selectedClientId
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                }).then((res) => {
                    this.loading = false;
                    this.new_files=[
                        {
                            'name': 'No file chosen',
                            'selected': false,
                        }
                    ];
                    this.$notify({
                        type:'success',
                        title: this.$t('success'),
                        message: 'File saved successfully.'
                    });
                    
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong')
                    });
                });
            },
            uploadWishlistSummaryTemplate() {
                this.loading = true;
                service.post('client/uploadEmployeeWishlistSummaryTemplate', {
                    'image_file': this.wishlist_files[0].img,
                    'file_name': this.wishlist_files[0].name,
                    // 'client_id': this.selectedClientId
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                }).then((res) => {
                    this.loading = false;
                    this.wishlist_files=[
                        {
                            'name': 'No file chosen',
                            'selected': false,
                        }
                    ];
                    this.$notify({
                        type:'success',
                        title: this.$t('success'),
                        message: 'File saved successfully.'
                    });
                    
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$notify.error({
                        title: this.$t('error'),
                        message: this.$t('something_went_wrong')
                    });
                });
            },
           
            getToken(){
                service.get('superadmin/getToken', {
                    'Authorization': this.userToken
                }).then((res) => {
                    console.log(res);
                    this.tokenConfig=res.data.result;
                    // this.bandwidthToken=this.resData.access_field;
                    // this.bandwidthToken=this.resData.secret_key;
                }).catch((err) => {
                    console.log(err);
                });
                
            },
            syncChannels(){
                service.get('superadmin/getFreshchatChannels', {
                    'Authorization': this.userToken
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Channels updated Successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },
            saveToken(){
                service.post('superadmin/saveToken', 
                {
                    'token': this.tokenConfig.bandwidth_token,
                    'secret': this.tokenConfig.bandwidth_secret,
                    'application_id': this.tokenConfig.bandwidth_application_id,
                    'id': this.tokenConfig.id
                },
                {
                    'Authorization': this.userToken
                }).then((res) => {
                    // console.log(res);
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Saved Successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },
            back(){
                
                this.$router.push({
                    path: `/clientList/`
                });
            }
        },
        mounted() {
          
        },
        created() {
            this.getToken();
        }
    }

</script>
<style scoped>
.c-common-btn--small.gsheet{
    display: inline-flex;
    flex-direction: row;
    padding: 6px 10px;
}

.gsheet-logo{
    height: 20px;
    width: 20px;
    margin-right: 5px;
}
.gsheet-text{
    padding: 0;
    margin-top: 3px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/superAdmin/adminConfig.vue